import * as React from 'react';

const SvgTrendDownArrow = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={'1em'}
    height={'1em'}
    viewBox={'0 0 11 21'}
    {...props}
  >
    <path
      d='M6.08066 20.7594C6.08091 20.7592 6.08119 20.759 6.08144 20.7587L10.3471 16.4724C10.6666 16.1513 10.6654 15.6319 10.3443 15.3122C10.0232 14.9926 9.50378 14.9939 9.18419 15.315L6.32031 18.1928L6.32032 0.820312C6.32032 0.367254 5.95306 -2.02509e-07 5.5 -2.22313e-07C5.04694 -2.42117e-07 4.67969 0.367254 4.67969 0.820312L4.67969 18.1928L1.81581 15.315C1.49622 14.9939 0.97684 14.9927 0.655729 15.3123C0.334536 15.6319 0.333429 16.1513 0.65294 16.4724L4.91856 20.7587C4.91881 20.759 4.9191 20.7592 4.91934 20.7594C5.24 21.0807 5.76107 21.0797 6.08066 20.7594Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgTrendDownArrow;
